import { setAbhaLoader } from "../redux/slices/abhaSlice";
import store from "../redux/store";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export const interceptor = async (url, options) => {
  //   const baseUrl = "https://abhaapi.nhp.gov.in/api/v1";
  store.dispatch(setAbhaLoader(true));
  // const baseUrl = "http://192.168.1.50:8092/api";
  // const baseUrl = "http://localhost:8095/api";
  const baseUrl='https://abdmapi.lalpathlabs.com/api';
  // const baseUrl = "https://abha.abym.us/api";
  // const baseUrl = "https://abdmlp-api-uat.abym.us/api";
  // const environment = "local";
  // const baseUrl =
  //   environment === "prod"
  //     ?
  //     : "http://localhost:8092/api";.

  const sessionToken = localStorage.getItem("sessionToken");
  const authToken = localStorage.getItem("authToken");
  const abhasession = localStorage.getItem("abhaSessionToken");

  if (options.isToken) {
    options.headers["session-token"] = sessionToken;
    options.headers["access-token"] = authToken;
    options.headers["abha-session"] = abhasession;
  }

  const fullUrl = `${baseUrl}${url}`;
  delete options.isToken;

  // const response = await fetch(fullUrl, options);

  // const finalResponse = await response.json();
  try {
    const response = await fetch(fullUrl, options);
    const data = await response.json();

    if (response.ok) {
      if (options.showMsg) {
        toast.success(data?.result?.message || "Request successful"); // You can customize message
      }
      return data;
    } else {
      if (options.showMsg) {
        toast.error(data?.result?.error?.message || "Something went wrong");
      }
      return data;
    }
  } catch (error) {
    toast.error(
      { error: true, message: error?.message } ||
        "Network error. Please try again."
    );
    console.error("Interceptor error:", error);
    return { error: true, message: error?.message };
  } finally {
    store.dispatch(setAbhaLoader(false));
  }
  //   if (response.status === 200) {
  //     return finalResponse;
  //   }

  //   if (!response.ok) {
  //     throw new Error("Network response was not ok");
  //   }
  // return finalResponse;
};
